import React, { useState, useEffect } from 'react';
import { Popover, MenuItem, Typography, IconButton } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const ColorDropdown = ({ colors = [], colorPicker = { hex: '#000000' }, setColor }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColor, setSelectedColor] = useState(colorPicker?.hex || '#000000');
  const [hoveredColorHex, setHoveredColorHex] = useState(''); // Stores the hex of the hovered color

  useEffect(() => {
    setSelectedColor(colorPicker?.hex || '#000000');
  }, [colorPicker?.hex]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (colorHex) => {
    setSelectedColor(colorHex);
    setColor(colorHex);
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'color-popover' : undefined;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '0px', alignItems: 'center' }}>
      <IconButton
        onClick={handleClick}
        style={{
          padding: '0',
          minWidth: '20px',
          minHeight: '20px',
          borderRadius: '50%',
          backgroundColor: selectedColor || 'gray',
          border: 'none',
        }}
      >
        <CircleIcon
          style={{
            fontSize: '30px',
            width: '20px',
            height: '20px',
            color: 'transparent',
          }}
        />
      </IconButton>
      <ArrowDropDownIcon
        onClick={handleClick}
        style={{
          fontSize: '15px',
          marginLeft: '5px',
          color: 'black',
        }}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            padding: '10px',
            maxWidth: '140px',
          }}
        >
          {colors.map((colorItem, ind) => {
            const displayHex = colorItem?.color || '#000000'; // The hex code
            const displayName = colorItem?.name || '';       // The name of the color

            return (
              <MenuItem
                key={ind}
                onClick={() => handleChange(displayHex)}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minWidth: '50px',
                  flexBasis: 'calc(50% - 10px)',
                  cursor: 'pointer',
                }}
              >
                <div
                  className="circle displayFlex align justify"
                  onMouseEnter={() => setHoveredColorHex(displayHex)}
                  onMouseLeave={() => setHoveredColorHex('')}
                  style={{
                    backgroundColor: displayHex,
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    border: selectedColor === displayHex ? '2px solid blue' : 'none',
                  }}
                />
                <Typography>
                  {hoveredColorHex === displayHex ? displayName : ''} {/* Display the name */}
                </Typography>
              </MenuItem>
            );
          })}
        </div>
      </Popover>
    </div>
  );
};

export default ColorDropdown;